import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNote1"><Path d="M3.5 3.5H20.5V16L16 20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 20.5V15.5H20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconNote1;
